module.exports = new __parcel__URL__("ebitda_performance.d2e303be.svg").toString();